import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { Autor } from '../../model/Autor';
import { RouterModule } from '@angular/router';
import { AutorxsService } from '../../services/autorxs.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-autorxs',
  imports: [CommonModule, MatCardModule, RouterModule, MatProgressSpinnerModule],
  templateUrl: './autorxs.component.html',
  styleUrl: './autorxs.component.scss'
})
export class AutorxsComponent {

  public showSpinner: boolean = true;

  constructor(private service: AutorxsService) { }

  autores: Autor[] = [];

  ngOnInit() {
    this.service.getAutores(1).subscribe(autores => {
      this.autores = autores.items.sort((a,b)=> a.order - b.order);
      this.showSpinner = false;
    });
  }

}
